var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"mr-2",attrs:{"src":"https://ucarecdn.com/72a08221-873b-46a5-9d58-ce417be32057/-/format/auto/-/resize/200x/","alt":"Tissl POS Logo","width":"16","height":"16"}})
}
var staticRenderFns = []

export { render, staticRenderFns }